import React from 'react';

// Single-select chip strip used above tables for stage/tier/year filters.
// Selected chip uses navy fill + white text (per design tokens).

interface Props<T extends string> {
  options: ReadonlyArray<{ value: T; label: string; count?: number }>;
  value: T;
  onChange: (next: T) => void;
}

function FilterChipStrip<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div className="chip-strip">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`chip ${value === opt.value ? 'active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
          {opt.count !== undefined && opt.count > 0 && (
            <span className="muted" style={{ marginLeft: 4 }}>
              · {opt.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}

export default FilterChipStrip;
